import { Modal } from "./ui/Modal";
import { TaskForm } from "./TaskForm";
import { useTaskStore } from "../stores/taskStore";
import { useUiStore } from "../stores/uiStore";

export function TaskEditorModal() {
  const { editorOpen, editingTaskId, setEditorOpen } = useUiStore();
  const task = useTaskStore((s) => s.allTasks.find((t) => t.id === editingTaskId));
  return (
    <Modal open={editorOpen} className="md:!max-w-[960px]">
      <TaskForm task={task} onClose={() => setEditorOpen(false)} />
    </Modal>
  );
}
